import { apiAxiosCMS } from 'services/api';
import { ContactDataProps } from 'types/ContactProps';

export const initialContactData: ContactDataProps = {
	phone: '',
	whatsapp: '',
	email: ''
};

export function normalizeContact(data: any): ContactDataProps {
	if (!data) return initialContactData;

	return {
		id: data.id || undefined,
		phone: data.phone || '',
		whatsapp: data.whatsapp || '',
		email: data.email || '',
		createdAt: data.createdAt || data.created_at || undefined,
		updatedAt: data.updatedAt || data.updated_at || undefined
	};
}

/**
 * Busca os dados de contato salvos na API.
 */
export async function getContactDataReq(): Promise<{
	isSuccess: boolean;
	data: ContactDataProps;
}> {
	try {
		const response = await apiAxiosCMS.get('/contacts');
		const resData = response.data;
		const items = Array.isArray(resData)
			? resData
			: resData?.data || (resData?.items ? resData.items : []);

		const contact = items[0] || (resData?.id ? resData : null);

		return {
			isSuccess: true,
			data: normalizeContact(contact)
		};
	} catch {
		return {
			isSuccess: false,
			data: initialContactData
		};
	}
}

/**
 * Salva os dados de contato através da API.
 * Se já possuir `id`, atualiza o contato existente (PATCH /contacts/:id).
 * Caso contrário, cria um novo registro (POST /contacts).
 */
export async function saveContactDataReq(data: ContactDataProps): Promise<{
	isSuccess: boolean;
	data: ContactDataProps;
}> {
	try {
		const payload = {
			phone: data.phone || '',
			whatsapp: data.whatsapp || '',
			email: data.email || ''
		};

		let response;
		if (data.id) {
			response = await apiAxiosCMS.patch(`/contacts/${data.id}`, payload);
		} else {
			response = await apiAxiosCMS.post('/contacts', payload);
		}

		return {
			isSuccess: true,
			data: normalizeContact(response.data)
		};
	} catch {
		return {
			isSuccess: false,
			data
		};
	}
}
